import { Box, Container, Flex, HStack, Text } from '@chakra-ui/react'
import Image from 'next/image'
import React from 'react'
import QshopLogo from '@assets/images/qshop_long_logo.svg'
import ProductNotFoundImage from '@assets/images/product-not-found.svg'
import Link from 'next/link'
import BackArrowIcon from '@components/icons/back-arrow-icon'
import { useRouter } from 'next/router'

const ProductNotFound = () => {

  const router = useRouter()

  return (
    <Flex
      align="center"
      direction="column"
      pb="10"
    >
      <Text
        textAlign="center"
        fontWeight="600"
        fontSize={{ base: '28px', lg: '40px' }}
        mt="5"
        width={{ base: '95%', md: '80%', lg: '70%' }}
      >
        Oops! Product not found.
      </Text>
      <Flex
        justify="center"
        align="center"
        direction="column"
        position="relative"
        mt={{ base: '3', md: '5', lg: '8' }}
      >
        <Box position="relative" flexShrink="1" w="full" h="200px" px="4">
          <Image
            src={ProductNotFoundImage}
            alt="Product not found"
            style={{ paddingRight: '12px', paddingLeft: '12px' }}
            fill
            priority
          />
        </Box>
        <Text
          align="center"
          fontWeight="400"
          fontSize={{ base: '24px', lg: '32px' }}
          mt="4"
          width={{ base: '95%', md: '80%', lg: '70%' }}
        >
          This product page is currently unavailable!
        </Text>

          <HStack
            spacing="8px"
            py="8px"
            borderBottom="1px solid black"
            px="2"
            cursor="pointer"
            onClick={() => router.back()}
          >
            <BackArrowIcon />
            <Text fontSize="20px">Go Back</Text>
          </HStack>
      </Flex>
    </Flex>
  )
}

export default ProductNotFound
